import { Component } from '@angular/core';
import { NavController, ToastController } from 'ionic-angular';
import { StartGamePage } from '../start-game/start-game';
import { JoinGamePage } from '../join-game/join-game';


@Component({
  templateUrl: 'home.html'
})
export class HomePage {
    name: String;
	constructor(public navCtrl: NavController, public toastCtrl: ToastController) {
        this.name = ''
	}
	startGame() {
        if (this.validateName()) {
            this.navCtrl.push(StartGamePage, { name: this.name });
        }
	}
    joinGame() {
        if (this.validateName()) {
            this.navCtrl.push(JoinGamePage, { name: this.name });
        }
    }
    validateName() {
        if (this.name === '') {
            let toast = this.toastCtrl.create({
              message: 'Please enter a valid name',
              duration: 3000
            });
            toast.present();
            return false;
        }
        return true;
    }
} 



// WEBPACK FOOTER //
// ./src/pages/home/home.ts